







































































































































































































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import ModalDelete from '@/app/ui/components/ModalDelete/index'
import ModalImage from '@/app/ui/components/ImageGallery/index.vue'
import ImageSelect from '@/app/ui/components/SelectImage/index.vue'
import { HomebannerModule } from '@/app/store/modules/homebanner'
import { defaultImage } from '@/utils/default'
@Component({
  components: {
    'modal-delete': ModalDelete,
    'modal-image': ModalImage,
    'image-select': ImageSelect,
  },
})
export default class extends Vue {
  @Prop({}) public dataTable
  @Prop({}) public onPageLimit
  @Prop({}) public onPageNumChanged
  @Prop({}) public fields: any[] | undefined
  @Prop({}) public selected: any[] | undefined
  @Prop({}) public imageDataCategory
  @Prop({}) public clearTableStatus
  @Prop({}) public isLoading

  @Watch('clearTableStatus')
  public onPropertyChanged(value: boolean, oldValue: boolean) {
    this.$refs.selectableTable.clearSelected()
  }
  public get isFilledDataTable() {
    return (
      this.dataTable !== undefined && this.dataTable.pagination !== undefined
    )
  }
  // Form Edit
  public id: number = 0
  public name: string = ''
  public image_id: number = 0
  public file = {
    image_id: 0,
    link: '',
  }

  // Validasi
  public get stateName(): boolean {
    return this.name.length >= 4 ? true : false
  }

  // Image Thumbnail Id
  public imageThumbnailId: any = {
    id: null,
    link: defaultImage,
  }

  public cancelImageThumbnailId() {
    this.imageThumbnailId.id = null
    this.imageThumbnailId.link = defaultImage
  }

  // Function Edit
  public funcEdit(item, index, button) {
    //  console.log('item', item)
    this.id = item.id
    this.name = item.name
    this.file = item.image
    this.$root.$emit('bv::show::modal', 'modal-edit', button)
  }

  public patchNotif(item, index, button) {
    if (this.stateName === false) {
      return
    } else {
      const dataToEdit = {
        id: this.id,
        name: this.name,
        imageId: this.file.image_id,
      }
      HomebannerModule.updateHomebanner(dataToEdit)
      this.$root.$emit('bv::hide::modal', 'modal-edit', button)
    }
  }

  public changeImageCoverId(item) {
    //  console.log('item')
    this.file.image_id = item.id
    this.file.link = item.link
  }

  public modalDelete = {
    id: 'modal-delete',
    idBanner: 0,
    title: '',
  }
  public optionsStatus = [{ text: 'Active' }, { text: 'Inactive' }]
  public optionsRecomended = [
    { value: 'true', text: 'Yes' },
    { value: 'false', text: 'No' },
  ]
  public $refs!: {
    selectableTable: HTMLFormElement
  }
  public postData: any = {
    id: 'modal-edit',
    title: '',
    status: 'Active',
    recomended: true,
    file: null,
    imageThumbnail: null,
    imageUrl: '',
  }
  public imageData = ''
  public onRowSelected(items) {
    this.$emit('onRowSelected', items)
  }
  public selectAllRows() {
    if (this.$props.selected.length === this.dataTable.data.length) {
      this.$refs.selectableTable.clearSelected()
    } else {
      this.$refs.selectableTable.selectAllRows()
    }
  }
  public previewImage(event) {
    const input = event.target
    if (input.files && input.files[0]) {
      const reader = new FileReader()
      reader.onload = (e: any) => {
        this.imageData = e.target.result
      }
      reader.readAsDataURL(input.files[0])
    }
  }

  public funcDelete(item, index, button) {
    if (this.$props.selected.length < 1) {
      this.modalDelete.idBanner = item.id
      this.modalDelete.title = item.name
      this.$root.$emit('bv::show::modal', this.modalDelete.id, button)
    }
  }
  public resetEditModal() {
    this.postData.title = ''
    this.imageData = ''
  }
  public resetDeleteModal() {
    this.modalDelete.idBanner = 0
    this.modalDelete.title = ''
  }
  public get buttonDisable(): boolean {
    if (this.$props.selected.length < 1) {
      return false
    } else {
      return true
    }
  }
  public get stateTitle(): boolean {
    return this.postData.title.length >= 4 ? true : false
  }
  public get invalidTitle(): string {
    if (this.postData.title.length > 4) {
      return ''
    } else if (this.postData.title.length > 0) {
      return 'Enter at least 4 characters'
    } else {
      return 'Please enter Bulletin Title'
    }
  }
  public get validTitle(): string {
    return this.stateTitle === true ? '' : ''
  }

  public deleteNotif() {
    const ids = [this.modalDelete.idBanner]
    HomebannerModule.deleteHomebanner({ ids })
    this.$root.$emit('bv::hide::modal', 'modal-delete')
  }
}
